<template>
    <v-container>
        <v-row class="center">
            <v-col sm="6" xl="5" cols="8">
                <v-card style="display: flex; flex-direction: column;" class="px-12 center py-5">
                    <v-card-title>
                        <h3 class="center card-title">Login</h3>
                    </v-card-title>
                    <v-form>
                        <v-text-field v-on:keyup.enter="AdminLogin" ref="userName" prepend-icon="mdi-account"
                            v-model="email" label="Username"></v-text-field>
                        <v-text-field v-on:keyup.enter="AdminLogin" ref="password" prepend-icon="mdi-lock"
                            v-model="password" label="Password" type="password"></v-text-field>
                        <v-row>
                            <a @click="ShowReset" style="margin-left: 2.5%;">Forgot Password</a>
                        </v-row>
                        <v-row class="my-4">
                            <v-btn class="center" @click="AdminLogin">Submit</v-btn>
                        </v-row>
                        <v-dialog v-model="loadingSpinner" width="400px">
                            <loader-dialog-card title="Logging In"></loader-dialog-card>
                        </v-dialog>
                        <v-dialog v-model="resetDialog" width="400px">
                            <v-card>
                                <v-btn @click="resetDialog = false" class="top-right-close-btn" icon>
                                    <v-icon>fas fa-times</v-icon>
                                </v-btn>
                                <v-card-title class="headline justify-center">Password Reset</v-card-title>
                                <v-row class="mx-9 center" dense>
                                    <v-text-field outlined v-on:keyup.enter="ResetPassword" ref="userName"
                                        v-model="resetEmail" label="Email"></v-text-field>
                                </v-row>
                                <v-row dense style="height: 50px;">
                                    <v-btn-toggle class="mr-6" style="margin-left: auto;" mandatory v-model="resetType"
                                        :selected-class="resetType == 'TEMP' ? 'business-icon' : 'user-icon'">
                                        <v-btn class="content-switch-btn temp-btn" value="TEMP">Email Temp</v-btn>
                                        <v-btn class="content-switch-btn link-btn" value="LINK">Link</v-btn>
                                    </v-btn-toggle>
                                </v-row>
                                <v-row class="py-4">
                                    <v-btn class="center" @click="ResetPassword">Reset</v-btn>
                                </v-row>
                            </v-card>
                        </v-dialog>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped lang="scss">
::v-deep .v-dialog {
    overflow-y: hidden !important;
    border-radius: 15px;
    height: unset !important;
}

#admin-login {
    width: 70%;
}

.link-btn {
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
}

.temp-btn {
    border-top-left-radius: 10px !important;
    border-bottom-left-radius: 10px !important;
}

.card-title {
    white-space: pre-wrap;
}
</style>

<script>
import { MongoMixins } from '../../mixins/mongo-mixins';
import LoaderDialogCard from '../../components/common/LoaderDialogCard.vue';

export default {
    name: 'business-login',
    data: () => ({
        email: null,
        password: null,
        resetEmail: null,
        resetType: 'TEMP',
        loadingSpinner: false,
        resetDialog: false,
    }),
    components: {
        'loader-dialog-card': LoaderDialogCard
    },
    mixins: [MongoMixins],
    methods: {
        ShowReset: function () {
            this.resetDialog = true
        },
        AdminLogin: function () {
            this.loadingSpinner = true
            this.$store
                .dispatch('AUTH_REQUEST', { email: this.email.trim(), password: this.password })
                .then(() => {
                    if (this.$store.getters.isAuthenticated) {
                        if(this.$store.getters.isContractor) {
                            this.$router.push({ name: 'contractor-dash' });
                        } else {
                            this.$router.push({ name: 'business-dash' });
                        }
                        this.loadingSpinner = false;
                    }
                    return false
                })
                .catch(e => {
                    console.log('adminLogin: ' + e)
                    setTimeout(() => {
                        this.loadingSpinner = false
                    }, 1000)
                })
        },
        ResetPassword: function () {
            this.requestPasswordReset(this.resetEmail, this.resetType).then(() => {
                this.resetDialog = false
            });
        },
    },
}
</script>
